import { Directive, HostListener, Input, inject } from '@angular/core';

import { AppDialogRef } from './dialog-ref';

@Directive({
  selector: '[appDialogClose]',
  standalone: true,
})
export class DialogCloseDirective {
  @Input('appDialogClose') result: unknown;

  private readonly dialogRef = inject(AppDialogRef, { optional: true });

  @HostListener('click')
  onClick(): void {
    this.dialogRef?.close(this.result as never);
  }
}
